import type { ICellRendererParams } from 'ag-grid-community'
import { ROUTES } from '@sportninja/common/constants/app'
import React from 'react'
import { Link } from 'react-router-dom'
import PersonCell from 'src/components/List/PersonCell'
import type { GameRosterPlayer } from '../../types'

/** NAME column: avatar + name (links to the player) + customer id. */
const PlayerNameCell = ({ data }: ICellRendererParams<GameRosterPlayer>) => {
  if (!data) {
    return null
  }
  return (
    <PersonCell
      className='player-list-player'
      item={data}
      subTitle={data.customer_identifier}
      compact
      as={Link}
      to={`${ROUTES.PLAYER_ROOT}/${data.id}`}
    />
  )
}

export default PlayerNameCell
